import { render, staticRenderFns } from "./LicenseOverviewBeta.vue?vue&type=template&id=5d0c256d&"
import script from "./LicenseOverviewBeta.vue?vue&type=script&lang=js&"
export * from "./LicenseOverviewBeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports